import { Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useCallback, useMemo, useState } from "react";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { Dialog } from "e.sic-platform.webclient/src/components/dialog/Dialog";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { useLocation, useNavigate } from "react-router-dom";

export default observer(function CheckoutFinalizerModal() {
    const location = useLocation();
    const navigate = useNavigate();
    
    const queryParams = new URLSearchParams(location.search);

    const fromCheckout = queryParams.has('success');
    const checkoutSuccess = useMemo(() => {
        if (fromCheckout) {
            return queryParams.get('success') === "true";
        }
    }, [])

    const [visible, setVisible] = useState(fromCheckout);

    const handleClose = useCallback(() => {
        setVisible(false);
        const newQueryParams = new URLSearchParams(location.search);
        newQueryParams.delete('success');
        const newUrl = location.pathname;
        navigate(newUrl, { replace: true }); 
    }, [location, navigate]);
    
    return (
        <Dialog
            isVisible={visible}
            titleKey={checkoutSuccess ? "shop.checkout.title.success" : "shop.checkout.title.failed"}
            onHide={handleClose}
            buttonOk={{
                textKey: "shop.checkout.button",
                action: handleClose
            }}
        >
            <Grid container justifyContent="center">
                {checkoutSuccess ? <SuccessCheckout /> : <FailedCheckout />}
            </Grid>
        </Dialog>
    )
});

const SuccessCheckout = () => {
    return (
        <div>
            <CheckCircle color="primary" sx={{fontSize: "200px"}}/>
            <div className="centered">{translationService.translate("shop.checkout.success")}</div>
        </div>
    )
}

const FailedCheckout = () => {
    return (
        <div>
            <Cancel color="error" sx={{fontSize: "200px"}}/>
            <div className="centered">{translationService.translate("shop.checkout.failed")}</div>
        </div>
    )
}